import { z } from 'zod';

import { type UnsafeFilter, unsafeFilterSchema } from '../filters/types';

export const viewStateSchema = z.object({
  filters: unsafeFilterSchema.array(),
});

export type ViewState = {
  filters: UnsafeFilter[];
};

export type View = {
  id: string;
  name: string;
  isSaved?: boolean;
  state?: ViewState;
};

export type AddViewInput = {
  name: string;
  state: ViewState;
};

export type UpdateViewInput = {
  id: string;
  name?: string;
  state?: ViewState;
};
